import { decodeToken } from "react-jwt";

export function setWithExpiry(key, value) {
    try {
      const payload = decodeToken(value);
      const expiry = payload.exp * 1000;
      const item = {
        value: value,
        expiry: expiry,
      }
      localStorage.setItem(key, JSON.stringify(item))
    } catch (error) {
      console.error("Error decodificando el token JWT:", error);
    }
  }